var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.src)?_c('iframe',{staticClass:"common-iframe",attrs:{"id":"commonIframe","src":_vm.src}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }